export default {
    selected_products: [],
    steps: {
        additional_info: {
            message: null
        }
    }
}